<template>
  <a
    href="/"
    class="flex-none items-center sm:items-start md:text-base transition-colors w-[180px]"
  >
    <img
      v-if="colorMode.value === 'dark'"
      src="../assets/images/xeovision_logo_for_dark_bg.svg"
      alt="Xeovision logo"
      class="w-full mt-[2px]"
    />
    <img
      v-else
      src="../assets/images/xeovision_logo_for_light_bg.svg"
      alt="Xeovision logo"
      class="w-full mt-[2px]"
    />
  </a>
</template>
<script setup lang="ts">
const colorMode = useColorMode();
</script>
